import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { Button } from '../Button/Button';

export interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

export const Modal: React.FC<ModalProps> = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  className = '',
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="ds-modal-overlay" />
        <div className="ds-modal-content-wrap">
          <Dialog.Content
            className={`ds-modal ds-modal-enter ${className}`}
            aria-describedby={description ? 'ds-modal-desc' : undefined}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, marginBottom: title || description ? 16 : 0 }}>
              <div>
                {title ? <Dialog.Title className="ds-modal__title">{title}</Dialog.Title> : null}
                {description ? (
                  <Dialog.Description id="ds-modal-desc" className="ds-modal__desc">
                    {description}
                  </Dialog.Description>
                ) : null}
              </div>
              <Dialog.Close asChild>
                <Button variant="ghost" size="sm" aria-label="Close">
                  <X size={20} />
                </Button>
              </Dialog.Close>
            </div>
            {children}
            {footer ? (
              <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
                {footer}
              </div>
            ) : null}
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Modal;
